<!--title -->
<app-modal-title
  [title]="formPageConfig.title | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="tw-w-full">
        <div class="tw-flex">
          <label class="tw-p-1">{{ "common.ip" | translate }}</label>
          <mat-slide-toggle
            formControlName="isIpRange"
            [(ngModel)]="isIpRange"
            (change)="changeIsRangeIp($event)"
          >
            {{ "common.ipRange" | translate }}</mat-slide-toggle
          >
        </div>

        <div *ngIf="!isIpRange" class="tw-flex-center tw-flex-col">
          <!-- ipAddress -->
          <form-field
            [(value)]="model.ipAddress"
            class="tw-w-[275px]"
            [control]="form?.get('ipAddress')"
            label="common.ipAddress"
          >
          </form-field>
        </div>

        <div *ngIf="isIpRange" class="tw-flex-center tw-flex-col">
          <!-- alert -->
          <div
            class="alert tw-bg-gray-50 dark:tw-bg-dark-200 border tw-mb-2 tw-mt-1 tw-w-full"
          >
            <details #alertDetails (click)="onChangeAlertDetails(alertDetails)">
              <summary class="tw-font-semibold text-navyBlue">
                {{ "common.help" | translate }}
                <span *ngIf="!isShowAlertDetails"
                  >( {{ "common.clickForMoreInfo" | translate }} )</span
                >
              </summary>
              <div
                class="tw-w-[225px]"
                [innerHTML]="'messages.rangeDetail' | translate"
              ></div>
            </details>
          </div>

          <div class="tw-flex">
            <form-field
              [value]="rangeIp"
              placeholder="254"
              (valueChange)="rangeIp = $event; changeValidators(isIpRange)"
              label="common.ipRange"
              class="tw-w-[175px]"
              [min]="+ipLastDigit"
              [max]="254"
              [control]="form?.get('rangeIp')"
            >
            </form-field>
            <div class="tw-w-[35px]">
              <span class="input-ip-range tw-mt-[4px] bg-inherit" dir="ltr"
                >|</span
              >
            </div>
            <form-field
              [value]="ip"
              placeholder="1.1.1.1"
              (valueChange)="ip = $event; getIpLastDigit()"
              label="common.ipAddress"
              [control]="form?.get('ip')"
            >
            </form-field>
          </div>
        </div>

        <!-- description -->
        <div class="tw-flex-center tw-flex-col">
          <form-textarea
            class="tw-w-full font-vazir-ui"
            label="common.description"
            [(value)]="model.description"
            [control]="form?.get('description')"
            [rows]="1"
            maxlength="100"
          >
          </form-textarea>
        </div>

        <!-- useToLoginPanel -->
        <div class="tw-w-full tw-py-2 tw-flex tw-justify-start tw-items-center">
          <mat-slide-toggle
            formControlName="useToLoginPanel"
            [(ngModel)]="model.useToLoginPanel"
          >
            {{ "common.useToLoginPanel" | translate }}
          </mat-slide-toggle>
        </div>

        <!-- useToCreateToken -->
        <div class="tw-w-full tw-py-2 tw-flex tw-justify-start tw-items-center">
          <mat-slide-toggle
            formControlName="useToCreateToken"
            [(ngModel)]="model.useToCreateToken"
          >
            {{ "common.useToCreateToken" | translate }}
          </mat-slide-toggle>
        </div>

        <!-- <div class="tw-mt-3 tw-mb-0" role="alert">
          <span class="small">{{'messages.getCurrentIpHelp1'|translate}}
            <button (click)="getCurrentIp()" type="button" class="btn btn-sm btn-outline-success tw-ml-2 tw-mr-2">
              {{'common.currentIp'|translate}}</button>{{'messages.getCurrentIpHelp2'|translate}}</span><br>
        </div> -->
      </div>
    </div>

    <!-- form btns-->
    <app-form-btns
      [loading]="loading"
      [form]="form"
      [isEdit]="formPageConfig.isEditMode"
      (onClose)="onClose()"
      (onSubmit)="onSubmit()"
    >
    </app-form-btns>
  </form>
</div>
